export default __webpack_public_path__ + "static/media/10.dc6a808a.png";